export const fontText = {
    NormalText : "Intro Light Regular",
    ButtonNHeaderText : "Intro Regular Regular",
    ItemPriceText : "Intro Cond Caps",
    boldText : "Intro Bold Regular"

};